import { ConfirmCustomHost, onConfirmCustom } from './_Templates/ConfirmCustom';
import { ConfirmNativeHost, onConfirmNative } from './_Templates/ConfirmNative';
import { ConfirmReactBootstrapHost, onConfirmReactBootstrap } from './_Templates/ConfirmReactBootstrap';
import { ConfirmSweetAlertHost, onConfirmSweetAlert, onConfirmBulkSweetAlert } from './_Templates/ConfirmSweetAlert';

/*
    🔥 REGISTRO DE IMPLEMENTACIONES DE CONFIRM

    De cara al llamador TODAS son iguales: confirm() devuelve una promesa
    con true o false. Lo que cambia es cómo lo logran:

    kind: 'hosted'     -> es un componente. Necesita <AppConfirmHost />.
                          (propio, react-bootstrap)
    kind: 'standalone' -> se dibuja solo. Host devuelve null.
                          (sweetalert2, nativo)

    ⚠️ Las dos hosted comparten ConfirmBody, así que se ven igual.
       SweetAlert usa tu SWAL2_ALERT_HELPER, con su propia estética.

    bulkConfirm es opcional: solo sweetalert lo tiene (código + palabra).
*/

export const CONFIRM_TEMPLATES = [

    {
        id: 'custom', label: 'Propio (sin librería)', kind: 'hosted',
        Host: ConfirmCustomHost, confirm: onConfirmCustom, bulkConfirm: null,
    },

    {
        id: 'reactBootstrap', label: 'React Bootstrap Modal', kind: 'hosted',
        Host: ConfirmReactBootstrapHost, confirm: onConfirmReactBootstrap, bulkConfirm: null,
    },

    {
        id: 'sweetAlert', label: 'SweetAlert2 (tu helper)', kind: 'standalone',
        Host: ConfirmSweetAlertHost, confirm: onConfirmSweetAlert, bulkConfirm: onConfirmBulkSweetAlert,
    },

    {
        id: 'native', label: 'Nativo del navegador', kind: 'standalone',
        Host: ConfirmNativeHost, confirm: onConfirmNative, bulkConfirm: null,
    },

];

export const CONFIRM_TEMPLATE_IDS = CONFIRM_TEMPLATES.map((item) => item.id);

const FALLBACK_TEMPLATE = CONFIRM_TEMPLATES[0];

export const onResolveConfirmTemplate = (id) => (
    CONFIRM_TEMPLATES.find((item) => item.id === id) ?? FALLBACK_TEMPLATE
);
